"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCaption = void 0;
const getCaption = ({ value, maxLength, label, texts }) => {
    const selectedLength = value.length;
    if (selectedLength > maxLength) {
        throw new Error(`Advanced filter error: selected length - ${selectedLength} when max is ${maxLength}. Checkout options or value.`);
    }
    if (selectedLength === 0) {
        return `${label} (${texts.captionNone})`;
    }
    if (selectedLength === maxLength) {
        return `${label} (${texts.captionAll})`;
    }
    return `${label} (${selectedLength} ${texts.captionOf} ${maxLength})`;
};
exports.getCaption = getCaption;
//# sourceMappingURL=getCaption.js.map